import type {
  AttitudeBehaviorCatalogItem,
  DailyHabitCatalogItem,
  FundamentalCatalogItem,
} from '@/api/types';

function byOrder<TItem extends { order: number }>(first: TItem, second: TItem): number {
  return first.order - second.order;
}

function activeHabits(fundamental: FundamentalCatalogItem): DailyHabitCatalogItem[] {
  return (fundamental.dailyHabits ?? []).filter(habit => habit.isActive);
}

/** Comportamientos activos del fundamental, ordenados por `order`. */
export function activeAttitudes(fundamental: FundamentalCatalogItem): AttitudeBehaviorCatalogItem[] {
  return (fundamental.attitudes ?? [])
    .filter(attitude => attitude.isActive)
    .sort(byOrder);
}

/** Hábitos activos asociados a un comportamiento, ordenados por `order`. */
export function activeHabitsForAttitude(
  fundamental: FundamentalCatalogItem,
  attitudeId: string,
): DailyHabitCatalogItem[] {
  return activeHabits(fundamental)
    .filter(habit => habit.attitudeBehaviorId === attitudeId)
    .sort(byOrder);
}

/**
 * Hábitos activos que el catálogo dejó sin comportamiento. Sin esta agrupación
 * quedarían inalcanzables en un fundamental que sí tiene comportamientos.
 */
export function orphanHabits(fundamental: FundamentalCatalogItem): DailyHabitCatalogItem[] {
  return activeHabits(fundamental)
    .filter(habit => !habit.attitudeBehaviorId)
    .sort(byOrder);
}

/** Todos los hábitos activos del fundamental, ordenados por `order`. */
export function allActiveHabits(fundamental: FundamentalCatalogItem): DailyHabitCatalogItem[] {
  return activeHabits(fundamental).sort(byOrder);
}
